@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.savings_application.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.savings_application.generated.resources/"

internal val Res.string.feature_apply_savings_button_apply: StringResource by lazy {
      StringResource("string:feature_apply_savings_button_apply", "feature_apply_savings_button_apply", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 62),
      ))
    }

internal val Res.string.feature_apply_savings_button_cancel: StringResource by lazy {
      StringResource("string:feature_apply_savings_button_cancel", "feature_apply_savings_button_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73, 51),
      ))
    }

internal val Res.string.feature_apply_savings_button_continue: StringResource by lazy {
      StringResource("string:feature_apply_savings_button_continue", "feature_apply_savings_button_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125, 57),
      ))
    }

internal val Res.string.feature_apply_savings_button_ok: StringResource by lazy {
      StringResource("string:feature_apply_savings_button_ok", "feature_apply_savings_button_ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 183, 43),
      ))
    }

internal val Res.string.feature_apply_savings_error_amount_empty: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_amount_empty", "feature_apply_savings_error_amount_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227, 88),
      ))
    }

internal val Res.string.feature_apply_savings_error_amount_invalid_decimal: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_amount_invalid_decimal", "feature_apply_savings_error_amount_invalid_decimal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316, 134),
      ))
    }

internal val Res.string.feature_apply_savings_error_amount_invalid_format: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_amount_invalid_format", "feature_apply_savings_error_amount_invalid_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 451, 105),
      ))
    }

internal val Res.string.feature_apply_savings_error_amount_too_large: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_amount_too_large", "feature_apply_savings_error_amount_too_large", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 557, 104),
      ))
    }

internal val Res.string.feature_apply_savings_error_amount_too_small: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_amount_too_small", "feature_apply_savings_error_amount_too_small", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 662, 92),
      ))
    }

internal val Res.string.feature_apply_savings_error_currency_required: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_currency_required", "feature_apply_savings_error_currency_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 755, 81),
      ))
    }

internal val Res.string.feature_apply_savings_error_frequency_invalid: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_frequency_invalid", "feature_apply_savings_error_frequency_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 837, 85),
      ))
    }

internal val Res.string.feature_apply_savings_error_frequency_required: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_frequency_required", "feature_apply_savings_error_frequency_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 923, 82),
      ))
    }

internal val Res.string.feature_apply_savings_error_lock_in_period_required: StringResource by
    lazy {
      StringResource("string:feature_apply_savings_error_lock_in_period_required", "feature_apply_savings_error_lock_in_period_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1006, 95),
      ))
    }

internal val Res.string.feature_apply_savings_error_minimum_opening_balance_required: StringResource
    by lazy {
      StringResource("string:feature_apply_savings_error_minimum_opening_balance_required", "feature_apply_savings_error_minimum_opening_balance_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1102, 116),
      ))
    }

internal val Res.string.feature_apply_savings_error_product_empty: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_product_empty", "feature_apply_savings_error_product_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1219, 85),
      ))
    }

internal val Res.string.feature_apply_savings_error_server: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_server", "feature_apply_savings_error_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1305, 142),
      ))
    }

internal val Res.string.feature_apply_savings_error_submit_failed: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_submit_failed", "feature_apply_savings_error_submit_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1448, 125),
      ))
    }

internal val Res.string.feature_apply_savings_error_too_many_attempts: StringResource by lazy {
      StringResource("string:feature_apply_savings_error_too_many_attempts", "feature_apply_savings_error_too_many_attempts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1574, 121),
      ))
    }

internal val Res.string.feature_apply_savings_label_applicant_name: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_applicant_name", "feature_apply_savings_label_applicant_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1696, 70),
      ))
    }

internal val Res.string.feature_apply_savings_label_currency: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_currency", "feature_apply_savings_label_currency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1767, 56),
      ))
    }

internal val Res.string.feature_apply_savings_label_details: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_details", "feature_apply_savings_label_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1824, 55),
      ))
    }

internal val Res.string.feature_apply_savings_label_field_officer: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_field_officer", "feature_apply_savings_label_field_officer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1880, 69),
      ))
    }

internal val Res.string.feature_apply_savings_label_fill_application_details: StringResource by
    lazy {
      StringResource("string:feature_apply_savings_label_fill_application_details", "feature_apply_savings_label_fill_application_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1950, 92),
      ))
    }

internal val Res.string.feature_apply_savings_label_frequency: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_frequency", "feature_apply_savings_label_frequency", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2114, 57),
      ))
    }

internal val Res.string.feature_apply_savings_label_frequency_type: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_frequency_type", "feature_apply_savings_label_frequency_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2043, 70),
      ))
    }

internal val Res.string.feature_apply_savings_label_lock_in_period: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_lock_in_period", "feature_apply_savings_label_lock_in_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2172, 70),
      ))
    }

internal val Res.string.feature_apply_savings_label_minimum_opening_balance: StringResource by
    lazy {
      StringResource("string:feature_apply_savings_label_minimum_opening_balance", "feature_apply_savings_label_minimum_opening_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2243, 91),
      ))
    }

internal val Res.string.feature_apply_savings_label_next: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_next", "feature_apply_savings_label_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2335, 48),
      ))
    }

internal val Res.string.feature_apply_savings_label_overdraft: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_overdraft", "feature_apply_savings_label_overdraft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2384, 57),
      ))
    }

internal val Res.string.feature_apply_savings_label_request_to_allow_overdraft: StringResource by
    lazy {
      StringResource("string:feature_apply_savings_label_request_to_allow_overdraft", "feature_apply_savings_label_request_to_allow_overdraft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2442, 98),
      ))
    }

internal val Res.string.feature_apply_savings_label_savings_product: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_savings_product", "feature_apply_savings_label_savings_product", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2541, 67),
      ))
    }

internal val Res.string.feature_apply_savings_label_submission_date: StringResource by lazy {
      StringResource("string:feature_apply_savings_label_submission_date", "feature_apply_savings_label_submission_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2609, 71),
      ))
    }

internal val Res.string.feature_apply_savings_section_fill_details: StringResource by lazy {
      StringResource("string:feature_apply_savings_section_fill_details", "feature_apply_savings_section_fill_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2681, 82),
      ))
    }

internal val Res.string.feature_apply_savings_status_failure: StringResource by lazy {
      StringResource("string:feature_apply_savings_status_failure", "feature_apply_savings_status_failure", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2941, 84),
      ))
    }

internal val Res.string.feature_apply_savings_status_failure_action: StringResource by lazy {
      StringResource("string:feature_apply_savings_status_failure_action", "feature_apply_savings_status_failure_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2764, 63),
      ))
    }

internal val Res.string.feature_apply_savings_status_failure_tip: StringResource by lazy {
      StringResource("string:feature_apply_savings_status_failure_tip", "feature_apply_savings_status_failure_tip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2828, 112),
      ))
    }

internal val Res.string.feature_apply_savings_status_success: StringResource by lazy {
      StringResource("string:feature_apply_savings_status_success", "feature_apply_savings_status_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3227, 72),
      ))
    }

internal val Res.string.feature_apply_savings_status_success_action: StringResource by lazy {
      StringResource("string:feature_apply_savings_status_success_action", "feature_apply_savings_status_success_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3026, 67),
      ))
    }

internal val Res.string.feature_apply_savings_status_success_tip: StringResource by lazy {
      StringResource("string:feature_apply_savings_status_success_tip", "feature_apply_savings_status_success_tip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3094, 132),
      ))
    }

internal val Res.string.feature_apply_savings_success_draft_saved: StringResource by lazy {
      StringResource("string:feature_apply_savings_success_draft_saved", "feature_apply_savings_success_draft_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3300, 97),
      ))
    }

internal val Res.string.feature_apply_savings_success_submit: StringResource by lazy {
      StringResource("string:feature_apply_savings_success_submit", "feature_apply_savings_success_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3398, 104),
      ))
    }

internal val Res.string.feature_apply_savings_title: StringResource by lazy {
      StringResource("string:feature_apply_savings_title", "feature_apply_savings_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3503, 71),
      ))
    }

internal val Res.string.feature_apply_savings_unsaved_changes_message: StringResource by lazy {
      StringResource("string:feature_apply_savings_unsaved_changes_message", "feature_apply_savings_unsaved_changes_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3575, 133),
      ))
    }

internal val Res.string.feature_apply_savings_unsaved_changes_title: StringResource by lazy {
      StringResource("string:feature_apply_savings_unsaved_changes_title", "feature_apply_savings_unsaved_changes_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3709, 75),
      ))
    }

internal val Res.string.feature_button_next: StringResource by lazy {
      StringResource("string:feature_button_next", "feature_button_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3785, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_apply_savings_button_apply", Res.string.feature_apply_savings_button_apply)
  map.put("feature_apply_savings_button_cancel", Res.string.feature_apply_savings_button_cancel)
  map.put("feature_apply_savings_button_continue", Res.string.feature_apply_savings_button_continue)
  map.put("feature_apply_savings_button_ok", Res.string.feature_apply_savings_button_ok)
  map.put("feature_apply_savings_error_amount_empty", Res.string.feature_apply_savings_error_amount_empty)
  map.put("feature_apply_savings_error_amount_invalid_decimal", Res.string.feature_apply_savings_error_amount_invalid_decimal)
  map.put("feature_apply_savings_error_amount_invalid_format", Res.string.feature_apply_savings_error_amount_invalid_format)
  map.put("feature_apply_savings_error_amount_too_large", Res.string.feature_apply_savings_error_amount_too_large)
  map.put("feature_apply_savings_error_amount_too_small", Res.string.feature_apply_savings_error_amount_too_small)
  map.put("feature_apply_savings_error_currency_required", Res.string.feature_apply_savings_error_currency_required)
  map.put("feature_apply_savings_error_frequency_invalid", Res.string.feature_apply_savings_error_frequency_invalid)
  map.put("feature_apply_savings_error_frequency_required", Res.string.feature_apply_savings_error_frequency_required)
  map.put("feature_apply_savings_error_lock_in_period_required", Res.string.feature_apply_savings_error_lock_in_period_required)
  map.put("feature_apply_savings_error_minimum_opening_balance_required", Res.string.feature_apply_savings_error_minimum_opening_balance_required)
  map.put("feature_apply_savings_error_product_empty", Res.string.feature_apply_savings_error_product_empty)
  map.put("feature_apply_savings_error_server", Res.string.feature_apply_savings_error_server)
  map.put("feature_apply_savings_error_submit_failed", Res.string.feature_apply_savings_error_submit_failed)
  map.put("feature_apply_savings_error_too_many_attempts", Res.string.feature_apply_savings_error_too_many_attempts)
  map.put("feature_apply_savings_label_applicant_name", Res.string.feature_apply_savings_label_applicant_name)
  map.put("feature_apply_savings_label_currency", Res.string.feature_apply_savings_label_currency)
  map.put("feature_apply_savings_label_details", Res.string.feature_apply_savings_label_details)
  map.put("feature_apply_savings_label_field_officer", Res.string.feature_apply_savings_label_field_officer)
  map.put("feature_apply_savings_label_fill_application_details", Res.string.feature_apply_savings_label_fill_application_details)
  map.put("feature_apply_savings_label_frequency", Res.string.feature_apply_savings_label_frequency)
  map.put("feature_apply_savings_label_frequency_type", Res.string.feature_apply_savings_label_frequency_type)
  map.put("feature_apply_savings_label_lock_in_period", Res.string.feature_apply_savings_label_lock_in_period)
  map.put("feature_apply_savings_label_minimum_opening_balance", Res.string.feature_apply_savings_label_minimum_opening_balance)
  map.put("feature_apply_savings_label_next", Res.string.feature_apply_savings_label_next)
  map.put("feature_apply_savings_label_overdraft", Res.string.feature_apply_savings_label_overdraft)
  map.put("feature_apply_savings_label_request_to_allow_overdraft", Res.string.feature_apply_savings_label_request_to_allow_overdraft)
  map.put("feature_apply_savings_label_savings_product", Res.string.feature_apply_savings_label_savings_product)
  map.put("feature_apply_savings_label_submission_date", Res.string.feature_apply_savings_label_submission_date)
  map.put("feature_apply_savings_section_fill_details", Res.string.feature_apply_savings_section_fill_details)
  map.put("feature_apply_savings_status_failure", Res.string.feature_apply_savings_status_failure)
  map.put("feature_apply_savings_status_failure_action", Res.string.feature_apply_savings_status_failure_action)
  map.put("feature_apply_savings_status_failure_tip", Res.string.feature_apply_savings_status_failure_tip)
  map.put("feature_apply_savings_status_success", Res.string.feature_apply_savings_status_success)
  map.put("feature_apply_savings_status_success_action", Res.string.feature_apply_savings_status_success_action)
  map.put("feature_apply_savings_status_success_tip", Res.string.feature_apply_savings_status_success_tip)
  map.put("feature_apply_savings_success_draft_saved", Res.string.feature_apply_savings_success_draft_saved)
  map.put("feature_apply_savings_success_submit", Res.string.feature_apply_savings_success_submit)
  map.put("feature_apply_savings_title", Res.string.feature_apply_savings_title)
  map.put("feature_apply_savings_unsaved_changes_message", Res.string.feature_apply_savings_unsaved_changes_message)
  map.put("feature_apply_savings_unsaved_changes_title", Res.string.feature_apply_savings_unsaved_changes_title)
  map.put("feature_button_next", Res.string.feature_button_next)
}
